<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :title="page"
        :breadcrumbs="breadcrumbs"
        icon="tune"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row justify="center" align="center">
        <v-col cols="12" align="right" v-if="hasPermissions('Create attribute')">
          <v-btn
              color="primary"
              align="right"
              @click="addNew"
          >
            Thêm thuộc tính
          </v-btn>
        </v-col>
        <v-col cols="12">
          <v-data-table
              :headers="headers"
              :items="attributes"
              :items-per-page="10"
              class="elevation-1"
          >
            <template v-slot:item.actions="{ item }">
              <v-icon small class="mr-2" @click="editItem(item)" v-if="hasPermissions('Update attribute')">
                mdi-pencil
              </v-icon>
              <v-icon small @click="deleteItem(item.id)" v-if="hasPermissions('Delete attribute')">
                mdi-delete
              </v-icon>
            </template>
          </v-data-table>
        </v-col>

        <!-- open dialog -->

        <v-dialog
            v-if="attributeDetail"
            v-model="dialog"
            persistent
            max-width="500px"
        >
          <v-card class="pa-4">
            <ValidationObserver ref="attribute">
            <v-card-title>
              <span class="text-h5 mx-3">Sửa thuộc tính</span>
            </v-card-title>
            <v-card-text>
              <v-row justify="center" align="center">
                <v-col cols="11">
                  <ValidationProvider  name="name"
                                       rules="required"
                                       v-slot="{ errors }">
                  <v-text-field
                      background-color="#EDF2F7"
                      label="Tên"
                      :name="'name'"
                      v-model="attributeDetail.name"
                      filled
                  ></v-text-field>
                    <span class="validate-error red--text">
                  {{ errors[0] }}
                 </span>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row justify="center" align="center">
                <v-btn @click="dialog = false" class="mr-5"> HỦY </v-btn>
                <v-btn color="primary" @click="update"> Cập nhật </v-btn>
              </v-row>
            </v-card-actions>
            </ValidationObserver>
          </v-card>
        </v-dialog>

        <v-dialog
            v-model="dialog2"
            persistent
            max-width="500px"
        >
          <v-card class="pa-4">
            <ValidationObserver ref="attribute1">
            <v-card-title>
              <span class="text-h5 mx-3">Thêm thuộc tính</span>
            </v-card-title>
            <v-card-text>
              <v-row justify="center" align="center">
                <v-col cols="11">
                  <ValidationProvider  name="name"
                                       rules="required"
                                       v-slot="{ errors }">
                  <v-text-field
                      background-color="#EDF2F7"
                      label="Tên"
                      :name="'name'"
                      v-model="attributeNew.name"
                      filled
                  ></v-text-field>
                    <span class="validate-error red--text">
                  {{ errors[0] }}
                 </span>
                  </ValidationProvider>
                </v-col>
              </v-row>
            </v-card-text>
            <v-card-actions>
              <v-row justify="center" align="center">
                <v-btn @click="dialog2 = false" class="mr-5"> HỦY </v-btn>
                <v-btn color="primary" @click="addNewItem"> Lưu </v-btn>
              </v-row>
            </v-card-actions>
            </ValidationObserver>
          </v-card>
        </v-dialog>
      </v-row>

    </v-container>
  </div>
</template>
<script>
import {
  GET_LIST_ATTRIBUTE,
  GET_DETAIL_ATTRIBUTE,
  UPDATE_ATTRIBUTE,
  SAVE_ATTRIBUTE,
  DELETE_ATTRIBUTE,
} from "@/store/modules/attribute";
import { GET_LIST_CATEGORY } from "@/store/modules/category";
import { mapGetters } from "vuex";
import {
  ValidationProvider,
  ValidationObserver,
  localize
} from 'vee-validate/dist/vee-validate.full';
export default {
  components: {
    ValidationProvider,
    ValidationObserver,
  },
  data() {
    return {
      page: "Quản lý thuộc tính",
      breadcrumbs: [
        {
          text: "Trang chủ",
          disabled: true,
        },
        {
          text: "Quản lý sản phẩm",
          disabled: true,
        },
        {
          text: "Quản lý thuộc tính",
          disabled: true,
        },
      ],
      headers: [
        { text: "Tên thuộc tính", value: "name", align: "start" },
        { text: "Actions", value: "actions", sortable: false ,align: "end"},
      ],
      dialog: false,
      dialog2: false,
      attributeNew: {
        name:''
      }
    };
  },
  computed: {
    ...mapGetters({
      attributes: "attributes",
      categories: "categories",
      attributeDetail: "attributeDetail",
    }),
  },
  mounted() {
    localize({
      vi: {
        names: {
          name:'Tên thuộc tính',
        },
        messages: {
          required: '{_field_} ' +'không được bỏ trống!',
        },
      }
    });
    localize('vi');
  },
  async created() {
    await this.$store.dispatch(GET_LIST_ATTRIBUTE);
    await this.$store.dispatch(GET_LIST_CATEGORY);
  },
  methods: {
    editItem(item) {
      this.$store.dispatch(`${GET_DETAIL_ATTRIBUTE}`, item.id).then((data) => {
        if (data) {
          this.dialog = true;
        }
      });
    },
    deleteItem(id)
    {
      confirm('Bạn có chắc muốn xóa?') &&
      this.$store.dispatch(`${DELETE_ATTRIBUTE}`,id).then(data=>{
        if(data && data.status === 1) {
          this.$store.dispatch(GET_LIST_ATTRIBUTE);
        }
      })
    },
    addNew(){
      this.dialog2 = true;
      this.attribute = true;
      this.attributeDetail.name='';
      this.attributeDetail.category_id='';
    },
    addNewItem() {
      let result = this.$refs.attribute1.validate()
      if(result) {
        if (!this.attributeNew.name) {
          return false
        }  else {
          this.$store.dispatch(`${SAVE_ATTRIBUTE}`,{name: this.attributeNew.name} ).then((data) => {
            if (data) {
              this.$toasted.success('Cập nhật thành công!', {
                duration:1000,
                position:'top-center'
              })
              this.dialog2 = false;
              this.$store.dispatch(GET_LIST_ATTRIBUTE);
            }
          });
        }
      }
    },
    update() {
      let result = this.$refs.attribute.validate()
      if(result) {
        if (!this.attributeDetail.name) {
          return false
        } else {
          this.$store.dispatch(`${UPDATE_ATTRIBUTE}`, this.attributeDetail).then((data) => {
            if (data) {
              this.$toasted.success('Cập nhật thành công!', {
                duration:1000,
                position:'top-center'
              })
              this.dialog = false;
              this.$store.dispatch(GET_LIST_ATTRIBUTE);
            }
          });
        }
      }
    },
  },
};
</script>
